module.exports = __webpack_public_path__ + "img/infoIcon.abe276f4.png";